import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { EmvioRow } from '@nexio/emvio-util-ui';
import { doesPropExistAndHasItChanged } from '@nexio/emvio-util-app';
import _ from 'lodash';
import { getKpiTransactionSummary, getKpiMonthlyChargebackCount } from './Widgets/kpiActions';
import {
    getIsMonthlyChargebackCountLoading,
    getMonthlyChargebackCountErrorMessage,
    getMonthlyChargebackCountMtdCount,
    getMonthlyChargebackCountPreviousMonthCount,
    getTransactionSummaryErrorMessage,
    getTransactionSummary,
    getTransactionSummaryIsLoading
} from './Widgets/kpiEntity';
import { toastIfError } from '../../utils/toast';
import TransactionChart from './TransactionChart/TransactionChart';
import mixpanel from '../../utils/mixpanel';
import { getResellerWidgetSettingsEntity } from './Widgets/ResellerWidgetSettings/resellerWidgetSettingsEntity';
import ResellerTransactionsWidget from './Widgets/ResellerTransactionsWidget/ResellerTransactionsWidget';
import ApproveDeclineWidget from './Widgets/ApproveDeclineWidget/ApproveDeclineWidget';
import SalesWidget from './Widgets/SalesWidget/SalesWidget';
import ChargebacksWidget from './Widgets/ChargebacksWidget/ChargebacksWidget';
import './ResellerDashboard.scss';
import BoardingStatusSummaryWidgetLegacy from '../BoardingStatusSummaryWidget/BoardingStatusSummaryWidgetLegacy';

export class ResellerDashboardLegacy extends Component {
    static propTypes = {
        monthlyChargebackCountErrorMessage: PropTypes.string,
        transactionSummaryErrorMessage: PropTypes.string,
        isMonthlyChargebackCountLoading: PropTypes.bool,
        isTransactionSummaryLoading: PropTypes.bool,
        onGetMonthlyChargebackCount: PropTypes.func,
        onGetTransactionSummary: PropTypes.func,
        settings: PropTypes.shape({
            currencyId: PropTypes.string,
            currencyCode: PropTypes.string
        }),
        mtdChargebackCount: PropTypes.number,
        previousMonthChargebackCount: PropTypes.number,
        transactionSummary: PropTypes.shape({
            yesterdaySaleAmount: PropTypes.number,
            yesterdaySaleCount: PropTypes.number,
            yesterdayDeclineCount: PropTypes.number,
            lastThirtySaleAmount: PropTypes.number,
            lastThirtySaleCount: PropTypes.number,
            lastThirtyRefundAmount: PropTypes.number,
            lastThirtyDeclineCount: PropTypes.number,
            previousThirtySaleAmount: PropTypes.number,
            previousThirtySaleCount: PropTypes.number,
            previousThirtyRefundAmount: PropTypes.number,
            lastThirtyAverageSaleAmount: PropTypes.number,
            yesterdayAverageSaleAmount: PropTypes.number,
            yesterdayVsLastThirtyAverageSaleAmount: PropTypes.number,
            lastThirtyVsPreviousThirtySaleCount: PropTypes.number,
            lastThirtyVsPreviousThirtySaleAmount: PropTypes.number,
            lastThirtyVsPreviousThirtyRefundAmount: PropTypes.number,
            lastThirtyApprovalPercentage: PropTypes.number,
            yesterdayApprovalPercentage: PropTypes.number,
            yesterdayVsLastThirtyApprovalPercentage: PropTypes.number,
            topDeclineReasons: PropTypes.array,
            monthToDaySaleCount: PropTypes.number,
            previousMonthToDaySaleCount: PropTypes.number
        })
    };

    componentDidMount() {
        mixpanel.track('Reseller Dashboard page mounted');

        const currencyId = _.get(this.props, 'settings.currencyId');
        this.props.onGetMonthlyChargebackCount(currencyId);
        this.props.onGetTransactionSummary(currencyId);
    }

    componentDidUpdate(prevProps) {
        toastIfError(prevProps, this.props, 'transactionSummaryErrorMessage');
        toastIfError(prevProps, this.props, 'monthlyChargebackCountErrorMessage');

        if (doesPropExistAndHasItChanged(prevProps, this.props, 'settings')) {
            const currencyId = _.get(this.props, 'settings.currencyId');

            this.props.onGetTransactionSummary(currencyId);
            this.props.onGetMonthlyChargebackCount(currencyId);
        }
    }

    renderBoardingStatusSummaryHeader = () => {
        return (<div className="boarding-status-summary-widget-header">Boarding Status</div>);
    };

    render() {
        const { transactionSummary, previousMonthChargebackCount, mtdChargebackCount } = this.props;

        return (
            <div className="emvio-reseller-dashboard">
                {this.renderBoardingStatusSummaryHeader()}
                <BoardingStatusSummaryWidgetLegacy />
                <EmvioRow>
                    <div className="title">
                        Aggregate Total Sales
                    </div>
                </EmvioRow>
                <div className="top-card" >
                    <TransactionChart />
                </div>
                <div className="widget-card">
                    <ResellerTransactionsWidget
                        lastThirtySaleCount={transactionSummary.lastThirtySaleCount}
                        lastThirtyVsPreviousThirtySaleCount={transactionSummary.lastThirtyVsPreviousThirtySaleCount}
                    />
                    <ApproveDeclineWidget
                        hasTransactionsFromYesterday={!!transactionSummary.yesterdaySaleCount || !!transactionSummary.yesterdayDeclineCount}
                        yesterdayApprovalPercentage={transactionSummary.yesterdayApprovalPercentage}
                        yesterdayVsLastThirtyApprovalPercentage={transactionSummary.yesterdayVsLastThirtyApprovalPercentage}
                        topDeclineReasons={transactionSummary.topDeclineReasons}
                    />
                    <SalesWidget
                        currencyCode={this.props.settings.currencyCode}
                        lastThirtySaleAmount={transactionSummary.lastThirtySaleAmount}
                        lastThirtyVsPreviousThirtySaleAmount={transactionSummary.lastThirtyVsPreviousThirtySaleAmount}
                        lastThirtyRefundAmount={transactionSummary.lastThirtyRefundAmount}
                        lastThirtyVsPreviousThirtyRefundAmount={transactionSummary.lastThirtyVsPreviousThirtyRefundAmount}
                    />
                    <ChargebacksWidget
                        mtdChargebackCount={mtdChargebackCount}
                        mtdTransactionCount={transactionSummary.monthToDaySaleCount}
                        previousMonthChargebackCount={previousMonthChargebackCount}
                        previousMonthTransactionCount={transactionSummary.previousMonthToDaySaleCount}
                    />
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        isMonthlyChargebackCountLoading: getIsMonthlyChargebackCountLoading(state),
        isTransactionSummaryLoading: getTransactionSummaryIsLoading(state),
        settings: getResellerWidgetSettingsEntity(state),
        monthlyChargebackCountErrorMessage: getMonthlyChargebackCountErrorMessage(state),
        mtdChargebackCount: getMonthlyChargebackCountMtdCount(state),
        previousMonthChargebackCount: getMonthlyChargebackCountPreviousMonthCount(state),
        transactionSummaryErrorMessage: getTransactionSummaryErrorMessage(state),
        transactionSummary: getTransactionSummary(state)
    };
}

function mapDispatchToProps(dispatch) {
    return {
        onGetMonthlyChargebackCount: (currencyId) => dispatch(getKpiMonthlyChargebackCount(currencyId)),
        onGetTransactionSummary: (currencyId) => dispatch(getKpiTransactionSummary(currencyId))
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(ResellerDashboardLegacy);
